(function (Translator) {
    // lv
    Translator.add("administration.user_search_button", "Mekl\u0113t", "EvpAdministrationBundle", "lv");
    Translator.add("administration.user_search_label", "Lietot\u0101ja ID", "EvpAdministrationBundle", "lv");
    Translator.add("forbidden", "Nav at\u013cauts", "EvpAdministrationBundle", "lv");
    Translator.add("internal_server_error", "Servera k\u013c\u016bda", "EvpAdministrationBundle", "lv");
    Translator.add("invalid_code", "Neder\u012bgs kods", "EvpAdministrationBundle", "lv");
    Translator.add("invalid_grant", "Piek\u013cuve ir liegta", "EvpAdministrationBundle", "lv");
    Translator.add("invalid_parameters", "Neder\u012bgi parametri", "EvpAdministrationBundle", "lv");
    Translator.add("invalid_request", "Nepareizs piepras\u012bjums", "EvpAdministrationBundle", "lv");
    Translator.add("invalid_state", "Neder\u012bgs status", "EvpAdministrationBundle", "lv");
    Translator.add("limits_exceeded", "Limits sasniegts", "EvpAdministrationBundle", "lv");
    Translator.add("logout", "Iziet", "EvpAdministrationBundle", "lv");
    Translator.add("not_acceptable", "Nav pie\u0146emts", "EvpAdministrationBundle", "lv");
    Translator.add("not_found", "Nav atrasts", "EvpAdministrationBundle", "lv");
    Translator.add("pagination.first", "Pirm\u0101", "EvpAdministrationBundle", "lv");
    Translator.add("pagination.last", "P\u0113d\u0113j\u0101", "EvpAdministrationBundle", "lv");
    Translator.add("pagination.next", "N\u0101kam\u0101", "EvpAdministrationBundle", "lv");
    Translator.add("pagination.page_out_of", "no", "EvpAdministrationBundle", "lv");
    Translator.add("pagination.previous", "Atpaka\u013c", "EvpAdministrationBundle", "lv");
    Translator.add("rate_limit_exceeded", "Limits sasniegts", "EvpAdministrationBundle", "lv");
    Translator.add("unauthorized", "Piek\u013cuve ir liegta", "EvpAdministrationBundle", "lv");
})(Translator);
